// extracted by mini-css-extract-plugin
module.exports = {"bbmk1gc":"bbmk1gc"};